
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $lfoFx = parcelRequire("lfoFx");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS",
            __cmplp.isLoading ? "_1UtDYzKGUX" : "_1UtDYzZqHV",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM4F84 _3138424F84 _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small",
            interactionName: "forge-content-tools-loading"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
Object.assign($ced39bfea5ef5993$export$9f275aff884e1431, {
    propTypes: {
        extension: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
        isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired
    }
});



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $cozmU.useState)(null);
    const [isLoading, setLoading] = (0, $cozmU.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $cozmU.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $cozmU.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $cozmU.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $cozmU.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $cozmU.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            } // Instrument the presence of non-content 3P content-action apps so
            // their keys are folded into the page-load `connectAppKeys` telemetry.
            if ((0, $9wGTI.fg)('cc_record_non_content_macros')) (0, $8wW9d.recordNonContentAppKeys)('content-tools', extensions.map((ext)=>ext?.id));
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $bDgLe.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("4Aa11"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("ectd2"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("1Gn4z"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("dWiWw"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("lCmw9"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("38qMF"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("65QAN"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("7XLRy"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("hj2Fo"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("bGZ5I"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("56Wsn"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("aIRAW"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("4Aa11", function(module, exports) {

let $35624b1329234f95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $35624b1329234f95$var$load("hUbK8"),
    $35624b1329234f95$var$load("LWh5V"),
    $35624b1329234f95$var$load("8NW7h"),
    $35624b1329234f95$var$load("b6SIr"),
    $35624b1329234f95$var$load("4XkGy"),
    $35624b1329234f95$var$load("1Gr4q"),
    $35624b1329234f95$var$load("219np"),
    $35624b1329234f95$var$load("4Mi85"),
    $35624b1329234f95$var$load("7G12e"),
    $35624b1329234f95$var$load("h4Nf7"),
    $35624b1329234f95$var$load("59hV4"),
    $35624b1329234f95$var$load("2la9m"),
    $35624b1329234f95$var$load("9pQri"),
    $35624b1329234f95$var$load("aLwQm"),
    $35624b1329234f95$var$load("iBJWz"),
    $35624b1329234f95$var$load("iZR3N"),
    $35624b1329234f95$var$load("jXM1T"),
    $35624b1329234f95$var$load("cvcNg"),
    $35624b1329234f95$var$load("6wr18"),
    $35624b1329234f95$var$load("4N1MY"),
    $35624b1329234f95$var$load("5MQ0D"),
    $35624b1329234f95$var$load("5dWeI"),
    $35624b1329234f95$var$load("cgDoV"),
    $35624b1329234f95$var$load("3iw68"),
    $35624b1329234f95$var$load("dRQNV"),
    $35624b1329234f95$var$load("kwVVP"),
    $35624b1329234f95$var$load("4x9Jx"),
    $35624b1329234f95$var$load("jL1Ke"),
    $35624b1329234f95$var$load("fuOfV"),
    $35624b1329234f95$var$load("kHXvF"),
    $35624b1329234f95$var$load("ea3NB"),
    $35624b1329234f95$var$load("ffEVr"),
    $35624b1329234f95$var$load("bbLnX"),
    $35624b1329234f95$var$load("1UUnk"),
    $35624b1329234f95$var$load("6Vp6A"),
    $35624b1329234f95$var$load("lYB2V"),
    $35624b1329234f95$var$load("djzm4"),
    $35624b1329234f95$var$load("cUdI6"),
    $35624b1329234f95$var$load("C3m1k"),
    $35624b1329234f95$var$load("5e5ry"),
    $35624b1329234f95$var$load("3GlNL"),
    $35624b1329234f95$var$load("kvIG3"),
    $35624b1329234f95$var$load("Wowvf"),
    $35624b1329234f95$var$load("2l8zo"),
    $35624b1329234f95$var$load("aAJyu"),
    $35624b1329234f95$var$load("f8Q8b"),
    $35624b1329234f95$var$load("hhss7"),
    $35624b1329234f95$var$load("cgKMu"),
    $35624b1329234f95$var$load("lnKog"),
    $35624b1329234f95$var$load("aAWLw"),
    $35624b1329234f95$var$load("7EorR"),
    $35624b1329234f95$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("ectd2", function(module, exports) {

let $a568d8056f1693af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a568d8056f1693af$var$load("hUbK8"),
    $a568d8056f1693af$var$load("LWh5V"),
    $a568d8056f1693af$var$load("8NW7h"),
    $a568d8056f1693af$var$load("b6SIr"),
    $a568d8056f1693af$var$load("4XkGy"),
    $a568d8056f1693af$var$load("1Gr4q"),
    $a568d8056f1693af$var$load("219np"),
    $a568d8056f1693af$var$load("4Mi85"),
    $a568d8056f1693af$var$load("7G12e"),
    $a568d8056f1693af$var$load("h4Nf7"),
    $a568d8056f1693af$var$load("59hV4"),
    $a568d8056f1693af$var$load("2la9m"),
    $a568d8056f1693af$var$load("9pQri"),
    $a568d8056f1693af$var$load("aLwQm"),
    $a568d8056f1693af$var$load("iBJWz"),
    $a568d8056f1693af$var$load("iZR3N"),
    $a568d8056f1693af$var$load("jXM1T"),
    $a568d8056f1693af$var$load("cvcNg"),
    $a568d8056f1693af$var$load("6wr18"),
    $a568d8056f1693af$var$load("4N1MY"),
    $a568d8056f1693af$var$load("5MQ0D"),
    $a568d8056f1693af$var$load("5dWeI"),
    $a568d8056f1693af$var$load("cgDoV"),
    $a568d8056f1693af$var$load("3iw68"),
    $a568d8056f1693af$var$load("dRQNV"),
    $a568d8056f1693af$var$load("kwVVP"),
    $a568d8056f1693af$var$load("4x9Jx"),
    $a568d8056f1693af$var$load("jL1Ke"),
    $a568d8056f1693af$var$load("fuOfV"),
    $a568d8056f1693af$var$load("kHXvF"),
    $a568d8056f1693af$var$load("ea3NB"),
    $a568d8056f1693af$var$load("ffEVr"),
    $a568d8056f1693af$var$load("bbLnX"),
    $a568d8056f1693af$var$load("1UUnk"),
    $a568d8056f1693af$var$load("6Vp6A"),
    $a568d8056f1693af$var$load("lYB2V"),
    $a568d8056f1693af$var$load("djzm4"),
    $a568d8056f1693af$var$load("cUdI6"),
    $a568d8056f1693af$var$load("C3m1k"),
    $a568d8056f1693af$var$load("5e5ry"),
    $a568d8056f1693af$var$load("3GlNL"),
    $a568d8056f1693af$var$load("kvIG3"),
    $a568d8056f1693af$var$load("Wowvf"),
    $a568d8056f1693af$var$load("2l8zo"),
    $a568d8056f1693af$var$load("aAJyu"),
    $a568d8056f1693af$var$load("f8Q8b"),
    $a568d8056f1693af$var$load("hhss7"),
    $a568d8056f1693af$var$load("cgKMu"),
    $a568d8056f1693af$var$load("lnKog"),
    $a568d8056f1693af$var$load("aAWLw"),
    $a568d8056f1693af$var$load("7EorR"),
    $a568d8056f1693af$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("1Gn4z", function(module, exports) {

let $139b9c70e6a986d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $139b9c70e6a986d1$var$load("hUbK8"),
    $139b9c70e6a986d1$var$load("LWh5V"),
    $139b9c70e6a986d1$var$load("8NW7h"),
    $139b9c70e6a986d1$var$load("b6SIr"),
    $139b9c70e6a986d1$var$load("4XkGy"),
    $139b9c70e6a986d1$var$load("1Gr4q"),
    $139b9c70e6a986d1$var$load("219np"),
    $139b9c70e6a986d1$var$load("4Mi85"),
    $139b9c70e6a986d1$var$load("7G12e"),
    $139b9c70e6a986d1$var$load("h4Nf7"),
    $139b9c70e6a986d1$var$load("59hV4"),
    $139b9c70e6a986d1$var$load("2la9m"),
    $139b9c70e6a986d1$var$load("9pQri"),
    $139b9c70e6a986d1$var$load("aLwQm"),
    $139b9c70e6a986d1$var$load("iBJWz"),
    $139b9c70e6a986d1$var$load("iZR3N"),
    $139b9c70e6a986d1$var$load("jXM1T"),
    $139b9c70e6a986d1$var$load("cvcNg"),
    $139b9c70e6a986d1$var$load("6wr18"),
    $139b9c70e6a986d1$var$load("4N1MY"),
    $139b9c70e6a986d1$var$load("5MQ0D"),
    $139b9c70e6a986d1$var$load("5dWeI"),
    $139b9c70e6a986d1$var$load("cgDoV"),
    $139b9c70e6a986d1$var$load("3iw68"),
    $139b9c70e6a986d1$var$load("dRQNV"),
    $139b9c70e6a986d1$var$load("kwVVP"),
    $139b9c70e6a986d1$var$load("4x9Jx"),
    $139b9c70e6a986d1$var$load("jL1Ke"),
    $139b9c70e6a986d1$var$load("fuOfV"),
    $139b9c70e6a986d1$var$load("kHXvF"),
    $139b9c70e6a986d1$var$load("ea3NB"),
    $139b9c70e6a986d1$var$load("ffEVr"),
    $139b9c70e6a986d1$var$load("bbLnX"),
    $139b9c70e6a986d1$var$load("1UUnk"),
    $139b9c70e6a986d1$var$load("6Vp6A"),
    $139b9c70e6a986d1$var$load("lYB2V"),
    $139b9c70e6a986d1$var$load("djzm4"),
    $139b9c70e6a986d1$var$load("cUdI6"),
    $139b9c70e6a986d1$var$load("C3m1k"),
    $139b9c70e6a986d1$var$load("5e5ry"),
    $139b9c70e6a986d1$var$load("3GlNL"),
    $139b9c70e6a986d1$var$load("kvIG3"),
    $139b9c70e6a986d1$var$load("Wowvf"),
    $139b9c70e6a986d1$var$load("2l8zo"),
    $139b9c70e6a986d1$var$load("aAJyu"),
    $139b9c70e6a986d1$var$load("f8Q8b"),
    $139b9c70e6a986d1$var$load("hhss7"),
    $139b9c70e6a986d1$var$load("cgKMu"),
    $139b9c70e6a986d1$var$load("lnKog"),
    $139b9c70e6a986d1$var$load("aAWLw"),
    $139b9c70e6a986d1$var$load("7EorR"),
    $139b9c70e6a986d1$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("dWiWw", function(module, exports) {

let $029e7113dbe8ffaf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $029e7113dbe8ffaf$var$load("hUbK8"),
    $029e7113dbe8ffaf$var$load("b6SIr"),
    $029e7113dbe8ffaf$var$load("1Gr4q"),
    $029e7113dbe8ffaf$var$load("219np"),
    $029e7113dbe8ffaf$var$load("4Mi85"),
    $029e7113dbe8ffaf$var$load("7G12e"),
    $029e7113dbe8ffaf$var$load("h4Nf7"),
    $029e7113dbe8ffaf$var$load("2la9m"),
    $029e7113dbe8ffaf$var$load("9pQri"),
    $029e7113dbe8ffaf$var$load("aLwQm"),
    $029e7113dbe8ffaf$var$load("iBJWz"),
    $029e7113dbe8ffaf$var$load("iZR3N"),
    $029e7113dbe8ffaf$var$load("jXM1T"),
    $029e7113dbe8ffaf$var$load("cvcNg"),
    $029e7113dbe8ffaf$var$load("6wr18"),
    $029e7113dbe8ffaf$var$load("4N1MY"),
    $029e7113dbe8ffaf$var$load("5dWeI"),
    $029e7113dbe8ffaf$var$load("cgDoV"),
    $029e7113dbe8ffaf$var$load("3iw68"),
    $029e7113dbe8ffaf$var$load("4x9Jx"),
    $029e7113dbe8ffaf$var$load("kHXvF"),
    $029e7113dbe8ffaf$var$load("ea3NB"),
    $029e7113dbe8ffaf$var$load("ffEVr"),
    $029e7113dbe8ffaf$var$load("bbLnX"),
    $029e7113dbe8ffaf$var$load("1UUnk"),
    $029e7113dbe8ffaf$var$load("6Vp6A"),
    $029e7113dbe8ffaf$var$load("lYB2V"),
    $029e7113dbe8ffaf$var$load("djzm4"),
    $029e7113dbe8ffaf$var$load("cUdI6"),
    $029e7113dbe8ffaf$var$load("C3m1k"),
    $029e7113dbe8ffaf$var$load("cgKMu"),
    $029e7113dbe8ffaf$var$load("5e5ry"),
    $029e7113dbe8ffaf$var$load("3GlNL"),
    $029e7113dbe8ffaf$var$load("kvIG3"),
    $029e7113dbe8ffaf$var$load("Wowvf"),
    $029e7113dbe8ffaf$var$load("2l8zo"),
    $029e7113dbe8ffaf$var$load("aAJyu"),
    $029e7113dbe8ffaf$var$load("f8Q8b"),
    $029e7113dbe8ffaf$var$load("hhss7"),
    $029e7113dbe8ffaf$var$load("aAWLw"),
    $029e7113dbe8ffaf$var$load("7EorR"),
    $029e7113dbe8ffaf$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("lCmw9", function(module, exports) {

let $fbce9d178161611d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fbce9d178161611d$var$load("hUbK8"),
    $fbce9d178161611d$var$load("b6SIr"),
    $fbce9d178161611d$var$load("1Gr4q"),
    $fbce9d178161611d$var$load("219np"),
    $fbce9d178161611d$var$load("4Mi85"),
    $fbce9d178161611d$var$load("7G12e"),
    $fbce9d178161611d$var$load("h4Nf7"),
    $fbce9d178161611d$var$load("2la9m"),
    $fbce9d178161611d$var$load("9pQri"),
    $fbce9d178161611d$var$load("aLwQm"),
    $fbce9d178161611d$var$load("iBJWz"),
    $fbce9d178161611d$var$load("iZR3N"),
    $fbce9d178161611d$var$load("jXM1T"),
    $fbce9d178161611d$var$load("cvcNg"),
    $fbce9d178161611d$var$load("6wr18"),
    $fbce9d178161611d$var$load("4N1MY"),
    $fbce9d178161611d$var$load("5dWeI"),
    $fbce9d178161611d$var$load("cgDoV"),
    $fbce9d178161611d$var$load("3iw68"),
    $fbce9d178161611d$var$load("4x9Jx"),
    $fbce9d178161611d$var$load("kHXvF"),
    $fbce9d178161611d$var$load("ea3NB"),
    $fbce9d178161611d$var$load("ffEVr"),
    $fbce9d178161611d$var$load("bbLnX"),
    $fbce9d178161611d$var$load("1UUnk"),
    $fbce9d178161611d$var$load("6Vp6A"),
    $fbce9d178161611d$var$load("lYB2V"),
    $fbce9d178161611d$var$load("djzm4"),
    $fbce9d178161611d$var$load("cUdI6"),
    $fbce9d178161611d$var$load("C3m1k"),
    $fbce9d178161611d$var$load("cgKMu"),
    $fbce9d178161611d$var$load("5e5ry"),
    $fbce9d178161611d$var$load("3GlNL"),
    $fbce9d178161611d$var$load("kvIG3"),
    $fbce9d178161611d$var$load("Wowvf"),
    $fbce9d178161611d$var$load("2l8zo"),
    $fbce9d178161611d$var$load("aAJyu"),
    $fbce9d178161611d$var$load("f8Q8b"),
    $fbce9d178161611d$var$load("hhss7"),
    $fbce9d178161611d$var$load("aAWLw"),
    $fbce9d178161611d$var$load("7EorR"),
    $fbce9d178161611d$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("38qMF", function(module, exports) {

let $2486e52a3fdca31f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2486e52a3fdca31f$var$load("hUbK8"),
    $2486e52a3fdca31f$var$load("b6SIr"),
    $2486e52a3fdca31f$var$load("1Gr4q"),
    $2486e52a3fdca31f$var$load("219np"),
    $2486e52a3fdca31f$var$load("4Mi85"),
    $2486e52a3fdca31f$var$load("7G12e"),
    $2486e52a3fdca31f$var$load("h4Nf7"),
    $2486e52a3fdca31f$var$load("2la9m"),
    $2486e52a3fdca31f$var$load("9pQri"),
    $2486e52a3fdca31f$var$load("aLwQm"),
    $2486e52a3fdca31f$var$load("iBJWz"),
    $2486e52a3fdca31f$var$load("iZR3N"),
    $2486e52a3fdca31f$var$load("jXM1T"),
    $2486e52a3fdca31f$var$load("cvcNg"),
    $2486e52a3fdca31f$var$load("6wr18"),
    $2486e52a3fdca31f$var$load("4N1MY"),
    $2486e52a3fdca31f$var$load("5dWeI"),
    $2486e52a3fdca31f$var$load("cgDoV"),
    $2486e52a3fdca31f$var$load("3iw68"),
    $2486e52a3fdca31f$var$load("4x9Jx"),
    $2486e52a3fdca31f$var$load("kHXvF"),
    $2486e52a3fdca31f$var$load("ea3NB"),
    $2486e52a3fdca31f$var$load("ffEVr"),
    $2486e52a3fdca31f$var$load("bbLnX"),
    $2486e52a3fdca31f$var$load("1UUnk"),
    $2486e52a3fdca31f$var$load("6Vp6A"),
    $2486e52a3fdca31f$var$load("lYB2V"),
    $2486e52a3fdca31f$var$load("djzm4"),
    $2486e52a3fdca31f$var$load("cUdI6"),
    $2486e52a3fdca31f$var$load("C3m1k"),
    $2486e52a3fdca31f$var$load("cgKMu"),
    $2486e52a3fdca31f$var$load("5e5ry"),
    $2486e52a3fdca31f$var$load("3GlNL"),
    $2486e52a3fdca31f$var$load("kvIG3"),
    $2486e52a3fdca31f$var$load("Wowvf"),
    $2486e52a3fdca31f$var$load("2l8zo"),
    $2486e52a3fdca31f$var$load("aAJyu"),
    $2486e52a3fdca31f$var$load("f8Q8b"),
    $2486e52a3fdca31f$var$load("hhss7"),
    $2486e52a3fdca31f$var$load("aAWLw"),
    $2486e52a3fdca31f$var$load("7EorR"),
    $2486e52a3fdca31f$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("65QAN", function(module, exports) {

let $46fc017f752bc08d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $46fc017f752bc08d$var$load("hUbK8"),
    $46fc017f752bc08d$var$load("b6SIr"),
    $46fc017f752bc08d$var$load("1Gr4q"),
    $46fc017f752bc08d$var$load("219np"),
    $46fc017f752bc08d$var$load("4Mi85"),
    $46fc017f752bc08d$var$load("7G12e"),
    $46fc017f752bc08d$var$load("h4Nf7"),
    $46fc017f752bc08d$var$load("2la9m"),
    $46fc017f752bc08d$var$load("9pQri"),
    $46fc017f752bc08d$var$load("aLwQm"),
    $46fc017f752bc08d$var$load("iBJWz"),
    $46fc017f752bc08d$var$load("iZR3N"),
    $46fc017f752bc08d$var$load("jXM1T"),
    $46fc017f752bc08d$var$load("cvcNg"),
    $46fc017f752bc08d$var$load("6wr18"),
    $46fc017f752bc08d$var$load("4N1MY"),
    $46fc017f752bc08d$var$load("5dWeI"),
    $46fc017f752bc08d$var$load("cgDoV"),
    $46fc017f752bc08d$var$load("3iw68"),
    $46fc017f752bc08d$var$load("4x9Jx"),
    $46fc017f752bc08d$var$load("kHXvF"),
    $46fc017f752bc08d$var$load("ea3NB"),
    $46fc017f752bc08d$var$load("ffEVr"),
    $46fc017f752bc08d$var$load("bbLnX"),
    $46fc017f752bc08d$var$load("1UUnk"),
    $46fc017f752bc08d$var$load("6Vp6A"),
    $46fc017f752bc08d$var$load("lYB2V"),
    $46fc017f752bc08d$var$load("djzm4"),
    $46fc017f752bc08d$var$load("cUdI6"),
    $46fc017f752bc08d$var$load("C3m1k"),
    $46fc017f752bc08d$var$load("5e5ry"),
    $46fc017f752bc08d$var$load("3GlNL"),
    $46fc017f752bc08d$var$load("kvIG3"),
    $46fc017f752bc08d$var$load("Wowvf"),
    $46fc017f752bc08d$var$load("2l8zo"),
    $46fc017f752bc08d$var$load("aAJyu"),
    $46fc017f752bc08d$var$load("f8Q8b"),
    $46fc017f752bc08d$var$load("hhss7"),
    $46fc017f752bc08d$var$load("cgKMu"),
    $46fc017f752bc08d$var$load("lnKog"),
    $46fc017f752bc08d$var$load("aAWLw"),
    $46fc017f752bc08d$var$load("7EorR"),
    $46fc017f752bc08d$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("7XLRy", function(module, exports) {

let $5cc32b9f8bfaf0dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5cc32b9f8bfaf0dc$var$load("hUbK8"),
    $5cc32b9f8bfaf0dc$var$load("b6SIr"),
    $5cc32b9f8bfaf0dc$var$load("4XkGy"),
    $5cc32b9f8bfaf0dc$var$load("1Gr4q"),
    $5cc32b9f8bfaf0dc$var$load("219np"),
    $5cc32b9f8bfaf0dc$var$load("4Mi85"),
    $5cc32b9f8bfaf0dc$var$load("7G12e"),
    $5cc32b9f8bfaf0dc$var$load("h4Nf7"),
    $5cc32b9f8bfaf0dc$var$load("59hV4"),
    $5cc32b9f8bfaf0dc$var$load("2la9m"),
    $5cc32b9f8bfaf0dc$var$load("9pQri"),
    $5cc32b9f8bfaf0dc$var$load("aLwQm"),
    $5cc32b9f8bfaf0dc$var$load("iBJWz"),
    $5cc32b9f8bfaf0dc$var$load("iZR3N"),
    $5cc32b9f8bfaf0dc$var$load("jXM1T"),
    $5cc32b9f8bfaf0dc$var$load("cvcNg"),
    $5cc32b9f8bfaf0dc$var$load("6wr18"),
    $5cc32b9f8bfaf0dc$var$load("4N1MY"),
    $5cc32b9f8bfaf0dc$var$load("5MQ0D"),
    $5cc32b9f8bfaf0dc$var$load("5dWeI"),
    $5cc32b9f8bfaf0dc$var$load("cgDoV"),
    $5cc32b9f8bfaf0dc$var$load("3iw68"),
    $5cc32b9f8bfaf0dc$var$load("dRQNV"),
    $5cc32b9f8bfaf0dc$var$load("kwVVP"),
    $5cc32b9f8bfaf0dc$var$load("4x9Jx"),
    $5cc32b9f8bfaf0dc$var$load("jL1Ke"),
    $5cc32b9f8bfaf0dc$var$load("fuOfV"),
    $5cc32b9f8bfaf0dc$var$load("kHXvF"),
    $5cc32b9f8bfaf0dc$var$load("ea3NB"),
    $5cc32b9f8bfaf0dc$var$load("ffEVr"),
    $5cc32b9f8bfaf0dc$var$load("bbLnX"),
    $5cc32b9f8bfaf0dc$var$load("1UUnk"),
    $5cc32b9f8bfaf0dc$var$load("6Vp6A"),
    $5cc32b9f8bfaf0dc$var$load("lYB2V"),
    $5cc32b9f8bfaf0dc$var$load("djzm4"),
    $5cc32b9f8bfaf0dc$var$load("cUdI6"),
    $5cc32b9f8bfaf0dc$var$load("C3m1k"),
    $5cc32b9f8bfaf0dc$var$load("5e5ry"),
    $5cc32b9f8bfaf0dc$var$load("3GlNL"),
    $5cc32b9f8bfaf0dc$var$load("kvIG3"),
    $5cc32b9f8bfaf0dc$var$load("Wowvf"),
    $5cc32b9f8bfaf0dc$var$load("2l8zo"),
    $5cc32b9f8bfaf0dc$var$load("aAJyu"),
    $5cc32b9f8bfaf0dc$var$load("f8Q8b"),
    $5cc32b9f8bfaf0dc$var$load("hhss7"),
    $5cc32b9f8bfaf0dc$var$load("cgKMu"),
    $5cc32b9f8bfaf0dc$var$load("lnKog"),
    $5cc32b9f8bfaf0dc$var$load("aAWLw"),
    $5cc32b9f8bfaf0dc$var$load("7EorR"),
    $5cc32b9f8bfaf0dc$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("hj2Fo", function(module, exports) {

let $c996478fb17591eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c996478fb17591eb$var$load("hUbK8"),
    $c996478fb17591eb$var$load("b6SIr"),
    $c996478fb17591eb$var$load("4XkGy"),
    $c996478fb17591eb$var$load("1Gr4q"),
    $c996478fb17591eb$var$load("219np"),
    $c996478fb17591eb$var$load("4Mi85"),
    $c996478fb17591eb$var$load("7G12e"),
    $c996478fb17591eb$var$load("h4Nf7"),
    $c996478fb17591eb$var$load("59hV4"),
    $c996478fb17591eb$var$load("2la9m"),
    $c996478fb17591eb$var$load("9pQri"),
    $c996478fb17591eb$var$load("aLwQm"),
    $c996478fb17591eb$var$load("iBJWz"),
    $c996478fb17591eb$var$load("iZR3N"),
    $c996478fb17591eb$var$load("jXM1T"),
    $c996478fb17591eb$var$load("cvcNg"),
    $c996478fb17591eb$var$load("6wr18"),
    $c996478fb17591eb$var$load("4N1MY"),
    $c996478fb17591eb$var$load("5MQ0D"),
    $c996478fb17591eb$var$load("5dWeI"),
    $c996478fb17591eb$var$load("cgDoV"),
    $c996478fb17591eb$var$load("3iw68"),
    $c996478fb17591eb$var$load("dRQNV"),
    $c996478fb17591eb$var$load("kwVVP"),
    $c996478fb17591eb$var$load("4x9Jx"),
    $c996478fb17591eb$var$load("jL1Ke"),
    $c996478fb17591eb$var$load("fuOfV"),
    $c996478fb17591eb$var$load("kHXvF"),
    $c996478fb17591eb$var$load("ea3NB"),
    $c996478fb17591eb$var$load("ffEVr"),
    $c996478fb17591eb$var$load("bbLnX"),
    $c996478fb17591eb$var$load("1UUnk"),
    $c996478fb17591eb$var$load("6Vp6A"),
    $c996478fb17591eb$var$load("lYB2V"),
    $c996478fb17591eb$var$load("djzm4"),
    $c996478fb17591eb$var$load("cUdI6"),
    $c996478fb17591eb$var$load("C3m1k"),
    $c996478fb17591eb$var$load("5e5ry"),
    $c996478fb17591eb$var$load("3GlNL"),
    $c996478fb17591eb$var$load("kvIG3"),
    $c996478fb17591eb$var$load("Wowvf"),
    $c996478fb17591eb$var$load("2l8zo"),
    $c996478fb17591eb$var$load("aAJyu"),
    $c996478fb17591eb$var$load("f8Q8b"),
    $c996478fb17591eb$var$load("hhss7"),
    $c996478fb17591eb$var$load("cgKMu"),
    $c996478fb17591eb$var$load("lnKog"),
    $c996478fb17591eb$var$load("aAWLw"),
    $c996478fb17591eb$var$load("7EorR"),
    $c996478fb17591eb$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("bGZ5I", function(module, exports) {

let $883301613d322d69$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $883301613d322d69$var$load("hUbK8"),
    $883301613d322d69$var$load("b6SIr"),
    $883301613d322d69$var$load("1Gr4q"),
    $883301613d322d69$var$load("219np"),
    $883301613d322d69$var$load("4Mi85"),
    $883301613d322d69$var$load("7G12e"),
    $883301613d322d69$var$load("h4Nf7"),
    $883301613d322d69$var$load("2la9m"),
    $883301613d322d69$var$load("9pQri"),
    $883301613d322d69$var$load("aLwQm"),
    $883301613d322d69$var$load("iBJWz"),
    $883301613d322d69$var$load("iZR3N"),
    $883301613d322d69$var$load("jXM1T"),
    $883301613d322d69$var$load("cvcNg"),
    $883301613d322d69$var$load("6wr18"),
    $883301613d322d69$var$load("4N1MY"),
    $883301613d322d69$var$load("5dWeI"),
    $883301613d322d69$var$load("cgDoV"),
    $883301613d322d69$var$load("3iw68"),
    $883301613d322d69$var$load("4x9Jx"),
    $883301613d322d69$var$load("kHXvF"),
    $883301613d322d69$var$load("ea3NB"),
    $883301613d322d69$var$load("ffEVr"),
    $883301613d322d69$var$load("bbLnX"),
    $883301613d322d69$var$load("1UUnk"),
    $883301613d322d69$var$load("6Vp6A"),
    $883301613d322d69$var$load("lYB2V"),
    $883301613d322d69$var$load("djzm4"),
    $883301613d322d69$var$load("cUdI6"),
    $883301613d322d69$var$load("C3m1k"),
    $883301613d322d69$var$load("cgKMu"),
    $883301613d322d69$var$load("5e5ry"),
    $883301613d322d69$var$load("3GlNL"),
    $883301613d322d69$var$load("kvIG3"),
    $883301613d322d69$var$load("Wowvf"),
    $883301613d322d69$var$load("2l8zo"),
    $883301613d322d69$var$load("aAJyu"),
    $883301613d322d69$var$load("f8Q8b"),
    $883301613d322d69$var$load("hhss7"),
    $883301613d322d69$var$load("aAWLw"),
    $883301613d322d69$var$load("7EorR"),
    $883301613d322d69$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("56Wsn", function(module, exports) {

let $3b8adb92ba3170a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b8adb92ba3170a3$var$load("hUbK8"),
    $3b8adb92ba3170a3$var$load("b6SIr"),
    $3b8adb92ba3170a3$var$load("1Gr4q"),
    $3b8adb92ba3170a3$var$load("219np"),
    $3b8adb92ba3170a3$var$load("4Mi85"),
    $3b8adb92ba3170a3$var$load("7G12e"),
    $3b8adb92ba3170a3$var$load("h4Nf7"),
    $3b8adb92ba3170a3$var$load("2la9m"),
    $3b8adb92ba3170a3$var$load("9pQri"),
    $3b8adb92ba3170a3$var$load("aLwQm"),
    $3b8adb92ba3170a3$var$load("iBJWz"),
    $3b8adb92ba3170a3$var$load("iZR3N"),
    $3b8adb92ba3170a3$var$load("jXM1T"),
    $3b8adb92ba3170a3$var$load("cvcNg"),
    $3b8adb92ba3170a3$var$load("6wr18"),
    $3b8adb92ba3170a3$var$load("4N1MY"),
    $3b8adb92ba3170a3$var$load("5dWeI"),
    $3b8adb92ba3170a3$var$load("cgDoV"),
    $3b8adb92ba3170a3$var$load("3iw68"),
    $3b8adb92ba3170a3$var$load("4x9Jx"),
    $3b8adb92ba3170a3$var$load("kHXvF"),
    $3b8adb92ba3170a3$var$load("ea3NB"),
    $3b8adb92ba3170a3$var$load("ffEVr"),
    $3b8adb92ba3170a3$var$load("bbLnX"),
    $3b8adb92ba3170a3$var$load("1UUnk"),
    $3b8adb92ba3170a3$var$load("6Vp6A"),
    $3b8adb92ba3170a3$var$load("lYB2V"),
    $3b8adb92ba3170a3$var$load("djzm4"),
    $3b8adb92ba3170a3$var$load("cUdI6"),
    $3b8adb92ba3170a3$var$load("C3m1k"),
    $3b8adb92ba3170a3$var$load("5e5ry"),
    $3b8adb92ba3170a3$var$load("3GlNL"),
    $3b8adb92ba3170a3$var$load("kvIG3"),
    $3b8adb92ba3170a3$var$load("Wowvf"),
    $3b8adb92ba3170a3$var$load("2l8zo"),
    $3b8adb92ba3170a3$var$load("aAJyu"),
    $3b8adb92ba3170a3$var$load("f8Q8b"),
    $3b8adb92ba3170a3$var$load("hhss7"),
    $3b8adb92ba3170a3$var$load("cgKMu"),
    $3b8adb92ba3170a3$var$load("lnKog"),
    $3b8adb92ba3170a3$var$load("aAWLw"),
    $3b8adb92ba3170a3$var$load("7EorR"),
    $3b8adb92ba3170a3$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("aIRAW", function(module, exports) {

let $7ce796451ae2e218$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7ce796451ae2e218$var$load("hUbK8"),
    $7ce796451ae2e218$var$load("b6SIr"),
    $7ce796451ae2e218$var$load("1Gr4q"),
    $7ce796451ae2e218$var$load("219np"),
    $7ce796451ae2e218$var$load("4Mi85"),
    $7ce796451ae2e218$var$load("7G12e"),
    $7ce796451ae2e218$var$load("h4Nf7"),
    $7ce796451ae2e218$var$load("2la9m"),
    $7ce796451ae2e218$var$load("9pQri"),
    $7ce796451ae2e218$var$load("aLwQm"),
    $7ce796451ae2e218$var$load("iBJWz"),
    $7ce796451ae2e218$var$load("iZR3N"),
    $7ce796451ae2e218$var$load("jXM1T"),
    $7ce796451ae2e218$var$load("cvcNg"),
    $7ce796451ae2e218$var$load("6wr18"),
    $7ce796451ae2e218$var$load("4N1MY"),
    $7ce796451ae2e218$var$load("5dWeI"),
    $7ce796451ae2e218$var$load("cgDoV"),
    $7ce796451ae2e218$var$load("3iw68"),
    $7ce796451ae2e218$var$load("4x9Jx"),
    $7ce796451ae2e218$var$load("kHXvF"),
    $7ce796451ae2e218$var$load("ea3NB"),
    $7ce796451ae2e218$var$load("ffEVr"),
    $7ce796451ae2e218$var$load("bbLnX"),
    $7ce796451ae2e218$var$load("1UUnk"),
    $7ce796451ae2e218$var$load("6Vp6A"),
    $7ce796451ae2e218$var$load("lYB2V"),
    $7ce796451ae2e218$var$load("djzm4"),
    $7ce796451ae2e218$var$load("cUdI6"),
    $7ce796451ae2e218$var$load("C3m1k"),
    $7ce796451ae2e218$var$load("5e5ry"),
    $7ce796451ae2e218$var$load("3GlNL"),
    $7ce796451ae2e218$var$load("kvIG3"),
    $7ce796451ae2e218$var$load("Wowvf"),
    $7ce796451ae2e218$var$load("2l8zo"),
    $7ce796451ae2e218$var$load("aAJyu"),
    $7ce796451ae2e218$var$load("f8Q8b"),
    $7ce796451ae2e218$var$load("hhss7"),
    $7ce796451ae2e218$var$load("cgKMu"),
    $7ce796451ae2e218$var$load("lnKog"),
    $7ce796451ae2e218$var$load("aAWLw"),
    $7ce796451ae2e218$var$load("7EorR"),
    $7ce796451ae2e218$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("8wW9d", function(module, exports) {
/* eslint-disable check-react-ssr-usage/guard-browser-globals -- Client-only instrumentation; non-content 3P apps are fetched and rendered on the client, never SSRed. */ /**
 * Instrumentation for third-party (3P) apps rendered OUTSIDE of page content
 * (e.g. byline, page banner, context menu, content tools, web panels).
 *
 * Unlike content macros/extensions (which are indexed from the ADF document by
 * `ExtrensionIndexProvider`), these apps are fetched client-side via GraphQL
 * hooks (`useWebItemLocation` / `useExtensionList`) and are therefore invisible
 * to the content-based telemetry.
 *
 * Each non-content surface calls `recordNonContentAppKeys` when its apps resolve.
 * The collected keys are stashed on a dedicated window global and later folded
 * into the page-load metric's `connectAppKeys` attribute (React UFO
 * `extra_properties`) by `pageLoadEventPlugin`, so they land in the same RUM
 * dataset as content app keys.
 */ const $eb9f67592b61ef7c$export$8fb2b6127d91a721 = '::';
const $eb9f67592b61ef7c$export$75dfc4b4563b78a5 = (source, appKeys)=>{
    if (typeof window === 'undefined') return;
    const keys = window.__NON_CONTENT_APP_KEYS__ ?? new Set();
    for (const key of appKeys)if (key) keys.add(`${source}${$eb9f67592b61ef7c$export$8fb2b6127d91a721}${key}`);
    window.__NON_CONTENT_APP_KEYS__ = keys;
};
const $eb9f67592b61ef7c$export$40caeb9e96de3450 = ()=>typeof window === 'undefined' ? new Set() : window.__NON_CONTENT_APP_KEYS__ ?? new Set();
const $eb9f67592b61ef7c$export$d36eed915298b207 = ()=>{
    if (typeof window === 'undefined') return;
    window.__NON_CONTENT_APP_KEYS__ = new Set();
};
module.exports["recordNonContentAppKeys"] = $eb9f67592b61ef7c$export$75dfc4b4563b78a5;
module.exports["getNonContentAppKeys"] = $eb9f67592b61ef7c$export$40caeb9e96de3450;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("845bO"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("845bO", function(module, exports) {

let $5df2b8faa1e95a32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5df2b8faa1e95a32$var$load("cgKMu"),
    $5df2b8faa1e95a32$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $8s9DV.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $kBr4q.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $kBr4q.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $kSwu1 = parcelRequire("kSwu1");


var $6TaGl = parcelRequire("6TaGl");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $kSwu1.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $kSwu1.useIntl)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $cozmU.useState)('auto');
    const dropdownMenuContainerRef = (0, $cozmU.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $hekY6.default)([
            "_2XsHFMuFDC _4ouGXIoWWg",
            isExternalCollaborator && "_2XsHFMdnbC _4ouGXIoWWg"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $cozmU.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId, preferPreloadedData: preferPreloadedData = false })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $cozmU.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: preferPreloadedData ? 'cache-first' : 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        },
        __callerPackage__: "access-requests"
    });
    // SSR-safe resolution signal, for consumers that render on the server. `true` as soon as the
    // answer is available in the store on the current render — including the server render, when the
    // result was SSR-preloaded and read via `cache-first`. Unlike `isLoadingForFirstTime`, this lets an
    // SSR consumer render the resolved copy directly into the server HTML.
    const isPendingRequestResolvedForSSR = shouldSkip || data !== undefined;
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime,
        isPendingRequestResolvedForSSR: isPendingRequestResolvedForSSR
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<4d7ccfc95dff4e3b611db90e9453df55>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ForgeContentTools.a0637f89.js.map
